import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RegistrationFormComponent } from 'src/app/components/registration-form/registration-form.component';
import { CreateUser, createuserdefaultvalues } from 'src/app/components/users/createuser';
import { BbInvitationService } from 'src/app/services/bb-invitation.service';
import { ToastService } from 'src/app/services/toast-service.service';
import { UserService } from 'src/app/services/user.service';

@Component({
    selector: 'app-register-bb-coached-participant',
    templateUrl: './register-bb-coached-participant.component.html',
    styleUrls: ['./register-bb-coached-participant.component.scss'],
    standalone: false
})
export class RegisterBbCoachedParticipantComponent {

  @ViewChild(RegistrationFormComponent) registrationForm!:RegistrationFormComponent; 
  createuserobj:CreateUser=createuserdefaultvalues();
  inviteguid:string=''
  isSubmitted:boolean=false
  constructor(private _userservice:UserService,private route:ActivatedRoute,public router:Router,private _bbinviteservice:BbInvitationService,private _toastservice:ToastService) { }

  ngOnInit(){
    this.route.params.subscribe(params => {
      this.inviteguid = params['guid'];
      this._bbinviteservice.getEmailFromInvitationGuid(this.inviteguid).subscribe({
        next: (response) => {
          this.createuserobj.userName=response.email;
        }
      })
    })
  }

  onSubmit(){
    this.isSubmitted=true;
    if(!this.registrationForm.validateRequiredFields())
    {
      this._toastservice.showErrorMessage("Please correct all the errors on the form")
      return;
    }
    
    this._userservice.registerBBCoachedParticipant(this.createuserobj,this.inviteguid).subscribe({
      next: (response) => {
        this.router.navigateByUrl("/account-created/bb");
      }
    })
  }
}
